export const getSubDomain = (hostname: string) => {
    const cleanHost = hostname.split(":")[0].toLowerCase(); // rimuove la porta
    const parts = cleanHost.split(".");

    // Se è localhost o *.localhost, prendi tutto tranne "localhost"
    if (cleanHost.includes("localhost")) {
        if (parts.length > 1) return parts.slice(0, -1).join(".");
        return "";
    }

    // Se dominio normale (es. sub.domain.com)
    return parts.length > 2 ? parts.slice(0, -2).join(".") : "";
};


export const getMainDomain = (location: Location) => {
    const hostname = location.hostname.toLowerCase().split(":")[0]; // rimuove la porta

    if (hostname.includes("localhost")) {
        return "localhost:3000"; // se vuoi aggiungere porta: location.port
    }

    const domainParts = hostname.split(".");
    return domainParts.slice(-2).join(".");
};
